import './houseplan.scss';
import './img/houseplan-background.svg';
import './img/houseplan-background-47-v1.svg';
